export default value => /^[0-9]*$/.test(value)



// WEBPACK FOOTER //
// ./src/custom_validators/number.js